import React, { useState } from "react";

import { AiOutlineSend } from "react-icons/ai";
import { HiArrowCircleUp } from "react-icons/hi";
import {
  AiFillTwitterCircle,
  AiOutlineGithub,
  AiFillLinkedin,
  AiOutlineInstagram,
} from "react-icons/ai";
import {
  MainContent,
  FooterTop,
  StyleForm,
  RadioStyles,
  StyleMessage,
  StyleBtn,
  StyleSocialbtns,
  StyleAside,
  StyleContainer,
  StyleFooterEnd,
} from "./Footer.styled";
import axios from "axios";

const Footer = () => {  
  const [submitForm, setSubmitForm] = useState("");
  const [inputName, setinputName] = useState("");
  const [inputEmail, setinputEmail] = useState("");
  const [inputRadio, setInputRadio] = useState("");
  const [inputOtherReason, setinputOtherReason] = useState("");
  const [inputMessage, setinputMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    // ? Destructuring the names to suit a certain convention
    const [name, email, radioBtn, otherReason, message] = [
      inputName,
      inputEmail,
      inputRadio,
      inputOtherReason,
      inputMessage,
    ];
    const formContents = {
      name,
      email,
      radioBtn,
      otherReason,
      message,
    };

    axios
      .post(
        "https://portfolio-backend-api-4ssu.onrender.com/api/persons/",
        formContents
      )
      .then((res) => {
        // console.log(res.data);
        setSubmitForm(formContents);
      });
    setinputName("");
    setinputEmail("");
    setinputOtherReason("");
    setinputMessage("");
  };

  const handleRadioBtns = (e) => {
    console.log(e.target.value);
    setInputRadio(e.target.value);
    console.log(inputRadio);
  };

  return (
    <div>
      <StyleContainer id="contact">
        <MainContent>
          <form onSubmit={handleSubmit}>
            <StyleForm>
              <FooterTop>
                ...Don't Just Scroll!!
                <span>Why not drop a message, so we could connect?</span>
              </FooterTop>
              <div className="name">
                <label htmlFor="name">
                  <div>Name*</div>
                  <input
                    type="text"
                    name="name"
                    autoComplete="off"
                    required
                    value={inputName}
                    onChange={(e) => setinputName(e.target.value)}
                  />
                </label>
              </div>

              <div className="email">
                <label htmlFor="email">
                  <div>Email*</div>
                  <input
                    type="email"
                    name="email"
                    autoComplete="off"
                    required
                    value={inputEmail}
                    onChange={(e) => setinputEmail(e.target.value)}
                  />
                </label>
              </div>

              <RadioStyles>
                <div className="radioBtns">
                  <label>
                    <input
                      type="radio"
                      name="category"
                      id="work"
                      value="work"
                      onClick={handleRadioBtns}
                    />
                    <span> Work </span>
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="category"
                      id="collabo"
                      value="collaboration"
                      onClick={handleRadioBtns}
                    />
                    <span>Collaboration</span>
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="category"
                      id="coffee-chat"
                      value="coffee-chat"
                      onClick={handleRadioBtns}
                    />
                    <span>Coffee Chat</span>
                  </label>
                </div>
                <div className="otherReason">
                  <label htmlFor="other">
                    <input
                      type="text"
                      name="other"
                      id="other"
                      placeholder="Other"
                      value={inputOtherReason}
                      onChange={(e) => setinputOtherReason(e.target.value)}
                    />
                  </label>
                </div>
              </RadioStyles>

              <StyleMessage>
                <label htmlFor="message">
                  <div>Message</div>
                  <textarea
                    name="message"
                    id="message"
                    minLength="4"
                    maxLength="50"
                    value={inputMessage}
                    onChange={(e) => setinputMessage(e.target.value)}
                  />
                </label>
              </StyleMessage>

              <StyleBtn>
                <button
                  onClick={() => {
                    setSubmitForm(!submitForm);
                  }}
                >
                  <div>
                    {" "}
                    Send Message <AiOutlineSend />
                  </div>
                </button>
              </StyleBtn>
            </StyleForm>
          </form>
        </MainContent>

        <StyleAside>
          <li className="otherOptions">Blog (Coming Soon)</li>
          <li className="otherOptions">
            <a href="mailto:praiseleye.pl@gmail.com?subject=Report a problem">
              Report a problem
            </a>
          </li>
          <li className="otherOptions">
            <a href="mailto:praiseleye.pl@gmail.com?subject=Send me a direct message">
              Send a Direct Message
            </a>
          </li>
          <li className="otherOptions">
            <a href="https://wa.me/message/UOXWAMTV66WUD1">Whatsapp</a>
          </li>
          <li className="otherOptions">
            <a href="#buyCoffee">Buy me a coffee</a>
          </li>
          <StyleSocialbtns className="socialIcons">
            <a
              href="https://twitter.com/Praiz_DcoDer"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillTwitterCircle />
            </a>

            <a
              href="https://github.com/Praizleye"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiOutlineGithub />
            </a>
            <a
              href="https://www.linkedin.com/in/praise-ogunleye-bb9244199"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillLinkedin />
            </a>
            <a href="#Blanks">
              <AiOutlineInstagram />
            </a>
          </StyleSocialbtns>
        </StyleAside>
      </StyleContainer>

      <StyleFooterEnd>
        <div className="copyright">&#169;Praise Ogunleye 2022</div>
        <div className="Top">
          {" "}
          <a href="#home">
            <span>
              {" "}
              Back to the Top <HiArrowCircleUp />
            </span>{" "}
            <span>
              <HiArrowCircleUp />
            </span>
          </a>
        </div>
      </StyleFooterEnd>
    </div>
  );
};

export default Footer;
